import { EMenuActionType } from '../../actions/menu';
import { IMenuState } from '../../types/menu';
import { TReduxActions } from '../../types/redux';

export const defaultState: IMenuState = {
  open: false,
};

export function menuReducer(state: IMenuState = defaultState, action: TReduxActions): IMenuState {
  switch (action.type) {
    case EMenuActionType.Open:
      return {
        ...state,
        open: true,
      };
    case EMenuActionType.Close:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
}
